const handleRecentlyViewedHelper = (item, recentlyViewed) => {
  let recentlyViewedUpdated = [...recentlyViewed];
  if (recentlyViewedUpdated.length === 0) {
    const cachedRecent = JSON.parse(
      localStorage.getItem("recentlyViewed")
    );
    if (cachedRecent) recentlyViewedUpdated = cachedRecent;
  }

  let itemExists;
  if (item.type === "load") {
    itemExists = recentlyViewedUpdated.find(({ type, loadId }) => type === item.type && loadId === item.loadId);
  } else if (item.type === "carrier") {
    itemExists = recentlyViewedUpdated.find(({ type, carrierId }) => type === item.type && carrierId === item.carrierId);
  }

  if (!itemExists) {
    if (recentlyViewedUpdated.length === 10 && recentlyViewedUpdated.some(({ isBookmark }) => isBookmark === false)) {
      const index = recentlyViewedUpdated.findLastIndex(({ isBookmark }) => isBookmark === false);
      recentlyViewedUpdated.splice(index, 1);
    }

    if (recentlyViewedUpdated.length < 10) recentlyViewedUpdated.unshift(item);

  } else if (itemExists && itemExists.type === "load" && itemExists.status != item.status) {
    let index = recentlyViewedUpdated.indexOf(itemExists);
    recentlyViewedUpdated[index] = item;
  }

  localStorage.setItem("recentlyViewed", JSON.stringify(recentlyViewedUpdated));
  return recentlyViewedUpdated;
};

const handleBookmarkHelper = (index, item, recentlyViewed) => {
  let recentlyViewedUpdated = [...recentlyViewed];
  item.isBookmark = !item.isBookmark;
  recentlyViewedUpdated[index] = item;
  localStorage.setItem("recentlyViewed", JSON.stringify(recentlyViewedUpdated));
  return recentlyViewedUpdated;
};

export { handleRecentlyViewedHelper, handleBookmarkHelper };